export default __webpack_public_path__ + "aa07f9b.png";